'use client';

import { c as _c } from "react/compiler-runtime";
import { DatePicker } from '@internations/ds';
import { trackEvent as trackGAEvent } from '@tracking/gtag';
import { useField } from '@util/Formik';
import dayjs, { Dayjs } from '@util/dayjs';
import { birthdayMax } from '@util/member/birthdayMax';
import { BasicFormValues } from '@util/registration/BasicFormModel';
import type { JSX } from 'react';
import { useEffect } from 'react';

// The picker slotProps types reject data-* attributes in object literals; spreading a constant avoids that
const birthdayTestId = {
  'data-testid': 'birthdayDatepicker'
};
const RegistrationBirthdayDatePicker = () => {
  const $ = _c(20);
  const [t0, t1, t2] = useField("birthday");
  const {
    value
  } = t0;
  const {
    error,
    touched
  } = t1;
  const {
    setValue: setDate,
    setTouched
  } = t2;
  const hasError = Boolean(touched && error);
  let t3;
  let t4;
  if ($[0] !== hasError) {
    t3 = () => {
      if (hasError) {
        trackGAEvent({
          eventName: "birthday_error",
          eventParams: {
            event_category: "registration",
            event_label: "rs06b"
          }
        });
      }
    };
    t4 = [hasError];
    $[0] = hasError;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== setDate) {
    t5 = date => {
      if (!dayjs.isDayjs(date)) {
        setDate(undefined, true);
        return;
      }
      setDate(date, true);
    };
    $[3] = setDate;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const onDateChange = t5;
  let t6;
  if ($[5] !== value) {
    t6 = dayjs.isDayjs(value) ? value : null;
    $[5] = value;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["year", "month", "day"];
    t8 = dayjs().subtract(100, "year");
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      actions: ["clear", "cancel", "accept"]
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== setTouched) {
    t10 = () => void setTouched(true);
    $[10] = setTouched;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = hasError ? error : null;
  let t12;
  if ($[12] !== hasError || $[13] !== t10 || $[14] !== t11) {
    t12 = {
      actionBar: t9,
      textField: {
        name: "birthday",
        onBlur: t10,
        fullWidth: true,
        error: hasError,
        helperText: t11,
        ...birthdayTestId
      }
    };
    $[12] = hasError;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== onDateChange || $[17] !== t12 || $[18] !== t6) {
    t13 = <DatePicker value={t6} onChange={onDateChange} openTo="year" views={t7} minDate={t8} maxDate={birthdayMax} label="Birthday" format="DD/MM/YYYY" closeOnSelect={true} slotProps={t12} />;
    $[16] = onDateChange;
    $[17] = t12;
    $[18] = t6;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};
export default RegistrationBirthdayDatePicker;